export default __webpack_public_path__ + "static/media/analysis-icon.8202f567.svg";